export default __webpack_public_path__ + "static/media/pa_1.99dffaed.mp3";